import { selectAll } from 'd3';

export default function clearCharts(chartContainer) {
    selectAll(chartContainer.find('path.line').get()).remove();
    selectAll(chartContainer.find('.s-graph-dot').get()).remove();
    selectAll(chartContainer.find('.chart-y-axis').get()).remove();
    selectAll(chartContainer.find('.chart-x-axis').get()).remove();
}
